// ============================================================
// FILE: resources/js/components/phoneInput.js
// USPATIH GO — Alpine Component: Phone Input (+62 / 0 normalizer)
// ============================================================

import Alpine from 'alpinejs';

Alpine.data('phoneInput', () => ({
  raw:   '',
  error: '',

  /**
   * Normalisasi nomor HP: +62/62 → 08xx
   * @returns {string}
   */
  get normalized() {
    const clean = this.raw.replace(/\D/g, '');
    if (clean.startsWith('62'))  return '0' + clean.slice(2);
    if (clean.startsWith('+62')) return '0' + clean.slice(3);
    return clean;
  },

  /**
   * Validasi format nomor HP Indonesia
   * @returns {boolean}
   */
  get isValid() {
    return /^08[0-9]{8,11}$/.test(this.normalized);
  },

  /**
   * Set error message jika tidak valid
   */
  validate() {
    this.error = this.isValid ? '' : 'Format nomor HP tidak valid. Contoh: 0812-3456-7890';
  },
}));
